import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

export function useFirestoreUser() {
  const { currentUser } = useAuth();
  const [firestoreUser, setFirestoreUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser?.uid) {
      setFirestoreUser(null);
      setLoading(false);
      return;
    }

    const fetchUserData = async () => {
      try {
        const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
        if (userDoc.exists()) {
          setFirestoreUser({
            ...currentUser,
            ...userDoc.data()
          });
        } else {
          setFirestoreUser(currentUser);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        setFirestoreUser(currentUser);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [currentUser]);

  return { firestoreUser, loading };
}